import { replace, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs, doc, setDoc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { Randomcode } from "../../components_root/rendom_code";
import { Toast } from "../../components_root/ToastContext";
import Cookies from "js-cookie";
export default function Accounting_groups_list_master() {

    const [group, setgroup] = useState("");
    const [group_title, setgroup_title] = useState("");
    const [account_type, setaccount_type] = useState("");
    const [IsLoading2, setIsLoading2] = useState(true);
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [accounting_groupsdata, setaccounting_groupsdata] = useState([]);
    const handleCreate = async () => {
        try {
            if (!group || !group.trim()) {
                Toastshow("Please enter group name.");
                return;
            }
            if (!group_title || !group_title.trim()) {
                Toastshow("Please enter group name.");
                return;
            }

            if (!account_type || !account_type.trim()) {
                Toastshow("Please enter account type.");
                return;
            }

            // ✅ normalize locally (DO NOT set state here)
            const group_normalized = group
                .trim()
                .toLowerCase()
                .replaceAll(" ", "_");

            const account_type_normalized = account_type
                .trim()
                .toLowerCase()
                .replaceAll(" ", "_");

            const voucherCollection = collection(
                db,
                "accounting_groups_list_master"
            );

            const duplicateQuery = query(
                voucherCollection,
                where("account_type", "==", account_type_normalized),
                where("group", "==", group_normalized)
            );

            const duplicateSnap = await getDocs(duplicateQuery);

            if (!duplicateSnap.empty) {
                Toastshow("Group already exists");
                return;
            }

            const groupid = Randomcode(16);

            const parentDocRef = doc(
                db,
                "accounting_groups_list_master",
                groupid
            );

            const data = {
                groupid,
                group: group_normalized, 
                group_title,
                account_type: account_type_normalized,
                date_time: new Date(),
            };

            await setDoc(parentDocRef, data);

            Toastshow("Accounting group saved successfully.");

            // ✅ reset UI only AFTER success

            setaccount_type("");

        } catch (error) {
            console.error(error);
            Toastshow(error?.message || "Something went wrong");
        }
    };
    useEffect(() => {
        // 🔹 master groups
        const masterQuery = query(
            collection(db, "accounting_groups_list_master")
        );

        const unsubscribeMaster = onSnapshot(masterQuery, (snapshot) => {
            const masterList = snapshot.docs.map((d) => ({
                id: d.id,
                ...d.data(),
            }));

            //setaccounting_groupsdata(masterList);
            setIsLoading2(false)
        });

        // ✅ cleanup
        return () => unsubscribeMaster();

    }, []);
useEffect(() => {
    const masterQuery = query(
        collection(db, "accounting_groups_list_master")
    );

    const unsubscribeMaster = onSnapshot(masterQuery, (snapshot) => {
        const rawList = snapshot.docs.map((d) => d.data());

        /*
          Result structure:
          [
            {
              group: "debit",
              titles: [
                {
                  group_title: "Fixed Assets",
                  account_types: [...]
                },
                {
                  group_title: "Current Assets",
                  account_types: [...]
                }
              ]
            }
          ]
        */

        const grouped = Object.values(
            rawList.reduce((acc, item) => {
                // group level (debit / credit)
                if (!acc[item.group]) {
                    acc[item.group] = {
                        group: item.group,
                        titles: {}
                    };
                }

                // group_title level (Fixed Assets / Current Assets)
                if (!acc[item.group].titles[item.group_title]) {
                    acc[item.group].titles[item.group_title] = new Set();
                }

                acc[item.group].titles[item.group_title].add(item.account_type);

                return acc;
            }, {})
        ).map(g => ({
            group: g.group,
            titles: Object.entries(g.titles).map(([title, types]) => ({
                group_title: title,
                account_types: Array.from(types)
            }))
        }));

        setaccounting_groupsdata(grouped);
        setIsLoading2(false);
    });

    return () => unsubscribeMaster();
}, []);



    return (
        <div>
            <div className="post-container p-2">
                <div className="post_updates">
                    <div className="items-back b-1 rounded p-2">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="text-h2 bold fcap">
                                            Accounting Groups
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            className="p-2"
                                            value={group}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // allow only letters, numbers & space
                                                {
                                                    setgroup(value);
                                                }
                                            }}
                                            maxLength={30}
                                            placeholder="Enter group name"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-h2 bold fcap">
                                            Groups title
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            className="p-2"
                                            value={group_title}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // allow only letters, numbers & space
                                                {
                                                    setgroup_title(value);
                                                }
                                            }}
                                            maxLength={30}
                                            placeholder="Enter group name"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-h2 bold">
                                            Account Type
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            className="p-2"
                                            value={account_type}

                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // allow only letters, numbers & space
                                                {
                                                    setaccount_type(value);
                                                }
                                            }}
                                            maxLength={30}
                                            placeholder="Enter account type"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <br />

                        <div
                            className="button-ui p-22 fill text-h1 cursor"
                            onClick={handleCreate}
                        >
                            Create
                        </div>
                    </div>
                </div>
                <div className="post_div">
      <div className="ui-grid">
    {IsLoading2 ? (
        <div className="text-h2 p-5">Loading...</div>
    ) : accounting_groupsdata.length === 0 ? (
        <div className="text-h2 bold p-5">No master available</div>
    ) : (
        accounting_groupsdata.map((grp) => (
            <div
                key={grp.group}
                className="ui-items items-back p-2 b-1 rounded"
            >
                {/* 🔹 Debit / Credit */}
                <div className="text-h2 bold fcap b-bottom p-1">
                    {grp.group.replaceAll("_", " ")}
                </div>

                {/* 🔹 Fixed Assets / Current Assets */}
                {grp.titles.map((title) => (
                    <div key={title.group_title} className="p-1">
                        <div className="text-h3 bold fcap">
                            {title.group_title}
                        </div>

                        {title.account_types.map((type, index) => (
                            <div
                                key={index}
                                className="text-h2 fcap p-left"
                            >
                                • {type.replaceAll("_", " ")}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        ))
    )}
</div>




                </div>
            </div>

        </div>
    );
}
